module.exports = __webpack_public_path__ + "img/skill_level_3_svg.32f1620f.svg";